(function() {
    'use strict';

    angular
        .module('ordiniApp')
        .controller('NavbarController', NavbarController);

    // inca$ - visualizzazione entità in base ai permessi
    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', 'LoginService', 'Permissions'];

    function NavbarController ($state, Auth, Principal, ProfileService, LoginService, Permissions) {
        var vm = this;

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        // inca$ - abilitazione voci menu
        vm.show = show;
        vm.showSuperUser = showSuperUser;

        ProfileService.getProfileInfo().then(function(response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;


        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        // inca$ - abilitazione voci menu
        function show(func) {
            return Permissions.hasPermission(func, "view");
        }

        // inca$ - abilitazione voci menu jhipster solo per superutente
        function showSuperUser() {
            return Permissions.hasRole('ROLE_SUPERUTENTE');
        }

    }
})();
